import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faCloudUploadAlt} from '@fortawesome/pro-solid-svg-icons';
import {canReimportAsset} from '../enablers';
import {AssetActionLabel} from '../locales';
import {type IAsset} from '../schema';
import {ASSET_EVENT} from './constants';

export const assetActionReimportIcon = faCloudUploadAlt;

/**
 * Reimport asset
 * @param params
 * @returns Action
 */
export const assetActionReimport = (
	asset?: IAsset,
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'asset-reimport',
	cb: () => dispatcher.trigger(ASSET_EVENT.REIMPORT, asset),
	enableTest: () => canReimportAsset(asset),
	icon: assetActionReimportIcon,
	get label() {
		return AssetActionLabel.REIMPORT;
	},
	...params,
});

export default assetActionReimport;
